import { UserLevel } from '@e3dc-react/shell/Types'
import { SERVICE_LEVELS_ALL } from 'src/Configuration'
import { AccountLinkModel } from '../models'

export const getHasInstallationWritingRights = (
  userLevel: UserLevel,
  accountLinks: AccountLinkModel[],
  userId?: string | number,
  userName?: string,
  companyId?: number,
  installationId?: number
): boolean => {
  if (SERVICE_LEVELS_ALL.includes(userLevel)) return true
  if (!installationId) return false

  const currentUserAccountLink = accountLinks.find(
    accountLink =>
      accountLink.accountId.toString() === userId?.toString() ||
      accountLink.userName === userName ||
      accountLink.accountId.toString() === companyId?.toString()
  )

  return currentUserAccountLink?.hasWriteAccess ?? false
}
